export const SET_INSPECTION_LIST_FILTER = "set_status_filter";

export function setFilter(status,startDate,endDate,inspectionIds) {
    return async (dispatch) => {
        dispatch({type:SET_INSPECTION_LIST_FILTER,payload:{status:status,startDate:startDate,endDate:endDate,inspectionIds:inspectionIds}});
    }
}




// WEBPACK FOOTER //
// ./src/actions/filter_actions.js